import { render, staticRenderFns } from "./NewComer.vue?vue&type=template&id=13895db0&"
import script from "./NewComer.vue?vue&type=script&lang=js&"
export * from "./NewComer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports